import { SVGProps } from 'react'

export const Book = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      d="M19.25 2.75H20V2H19.25V2.75ZM19.25 21.25V22H20V21.25H19.25ZM19.25 16.75V17.5H20V16.75H19.25ZM8.75 6.25H8V7.75H8.75V6.25ZM15.25 7.75H16V6.25H15.25V7.75ZM8.75 10.25H8V11.75H8.75V10.25ZM12.25 11.75H13V10.25H12.25V11.75ZM6.75 3.5H19.25V2H6.75V3.5ZM18.5 2.75V21.25H20V2.75H18.5ZM19.25 20.5H6.75V22H19.25V20.5ZM5.5 19.25V4.75H4V19.25H5.5ZM6.75 20.5C6.05964 20.5 5.5 19.9404 5.5 19.25H4C4 20.7688 5.23122 22 6.75 22V20.5ZM6.75 2C5.23122 2 4 3.23122 4 4.75H5.5C5.5 4.05964 6.05964 3.5 6.75 3.5V2ZM18.5 12V16.75H20V12H18.5ZM19.25 16H7V17.5H19.25V16ZM7 22H10V20.5H7V22ZM4 19C4 20.6569 5.34315 22 7 22V20.5C6.17157 20.5 5.5 19.8284 5.5 19H4ZM7 16C5.34315 16 4 17.3431 4 19H5.5C5.5 18.1716 6.17157 17.5 7 17.5V16ZM8.75 7.75H15.25V6.25H8.75V7.75ZM8.75 11.75H12.25V10.25H8.75V11.75Z"
      fill="currentColor"
    />
  </svg>
)

